import { limitDecimal } from './limitDecimal';

export function verifyWeightLossPercentage(
  weight: number,
  habitualWeight: number
) {
  return limitDecimal(((habitualWeight - weight) * 100) / habitualWeight) || 0;
}
